/* 
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = "menu-sub-hidden";

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
// export const defaultLocale = navigator.language.split('-')[0] || 'en';
export const localeOptions = [
  { id: "en", name: "English", direction: "ltr" },
  { id: "tr", name: "Türkçe", direction: "ltr" },
  { id: "ar", name: "عربي", direction: "rtl" },
  { id: "es", name: "Español", direction: "ltr" }
];
export const defaultLocale = "en";

export const firebaseConfig = {
  //   apiKey: 'AIzaSyBBksq-Asxq2M4Ot-75X19IyrEYJqNBPcg',
  //   authDomain: 'gogo-react-login.firebaseapp.com',
  //   databaseURL: 'https://gogo-react-login.firebaseio.com',
  //   projectId: 'gogo-react-login',
  //   storageBucket: 'gogo-react-login.appspot.com',
  //   messagingSenderId: '216495999563'
};

export const searchPath = "/app/pages/search";
// TODO CHANGE SERVICEPATH
export const servicePath = "https://api.coloredstrategies.com";

/* 
Color Options:
"light.purple", "light.blue", "light.green", "light.orange", "light.red", "dark.purple", "dark.blue", "dark.green", "dark.orange", "dark.red"
*/
export const isMultiColorActive = false;
export const defaultColor = "light.purple";
export const defaultDirection = "ltr";
export const isDarkSwitchActive = false;
export const themeColorStorageKey = "__theme_color";

const requestStatusEnum = {
  OPEN: "request.status_open",
  PENDING: "request.status_pending",
  CLOSED: "request.status_closed",
  CANCELED: "request.status_canceled"
};

const requestPayableStatusEnum = {
  paid: "request.payable_status_paid",
  canceled: "request.payable_status_canceled",
  awaiting_payment: "request.payable_status_awaiting_payment"
};

const bookingStatusEnum = {
  hotel_guest: "booking.status_hotel_guest",
  awaiting_approval: "booking.status_awaiting_approval",
  invalid_booking: "booking.status_invalid_booking",
  checked_out: "booking.status_checked_out",
  future_guest: "booking.status_future_guest"
};

const molainnKeylessAccessStatusEnum = {
  //verified, pending, rejected, expired
  verified: "booking.molainn_keyless_access_status_verified",
  pending: "booking.molainn_keyless_access_status_pending",
  rejected: "booking.molainn_keyless_access_status_rejected",
  expired: "booking.molainn_keyless_access_status_expired"
};

export default {
  requestStatusEnum,
  requestPayableStatusEnum,
  bookingStatusEnum,
  molainnKeylessAccessStatusEnum
};
